import { useParams } from "@tanstack/react-router";

export const useAllParams = () => {
  return useParams({ strict: false });
};

export const useBasePath = () => {
  const { accountName } = useAllParams();

  return location.pathname.startsWith("admin")
    ? accountName
      ? `/admin/${accountName}`
      : "/admin"
    : accountName
      ? `/${accountName}`
      : "/";
};

export const usePathAccountName = (): string => {
  const { accountName } = useAllParams();
  if (!accountName) {
    throw new Error("Account name is not defined");
  }
  return accountName;
};

export const useIsAdmin = () => {
  return location.pathname.startsWith("/admin");
};
export const useIsSubscription = () => {
  return location.pathname.startsWith("/subscription");
};
